import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=82749072&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"
import style0 from "./EventModal.vue?vue&type=style&index=0&id=82749072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82749072",
  null
  
)

export default component.exports